import { render } from "./partnerAccounts.vue?vue&type=template&id=2545c95e"
import script from "./partnerAccounts.vue?vue&type=script&lang=js"
export * from "./partnerAccounts.vue?vue&type=script&lang=js"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__